class skfValue {
  attr: string;
  exp: any;
  $value: any;

  constructor(private elem, private field: any) {
    this.attr = this.elem.getAttribute("skf-value");
    if (/\$value/.test(this.attr)) {
      const optionIndex = parseInt(this.elem.getAttribute("skf-options"), 10);
      this.$value = this.field.listOptions[optionIndex];
    }
    this.exp = new Function(
      "const $field = this.field; const $value = this.$value; return " +
        this.attr
    );
  }

  update(): void {
    const value = this.exp.call(this);
    this.elem.value = value || null;
  }
}

export { skfValue };
